import styled from 'styled-components';
import { ApButtonIcon, colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const Content = styled.div`
	display: flex;
	height: 100%;
	overflow: hidden;
	height: ${props => `${props.height || 440}px`};
	min-height: ${props => `${props.height || 440}px`};
	max-height: calc(100vh - 120px);
`;

export const ContentWrapper = styled.div`
	height: 100%;
	display: flex;
`;

export const ColumnWrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const HeadlinesContainer = styled.div`
	width: 292px;
	background-color: ${colors.grey1};
	height: auto;
	max-height: 440px;
	padding: 32px;
	overflow-y: auto;
	border-right: 1px solid ${colors.grey3};
	border-bottom: 1px solid ${colors.grey3};
`;

export const HeadlinesTitle = styled.div`
	font-size: 23px;
	font-weight: 500;
	color: ${colors.black};
	max-width: 224px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const HeadlinesLabel = styled.div`
	font-size: 11px;
	font-weight: 400;
	color: ${colors.grey5};
	margin-top: 16px;
`;

export const HeadlinesValue = styled.div`
	font-size: 19px;
	font-weight: 500;
	color: ${colors.grey8};
`;

export const Divider = styled.div`
	border-left: 1px solid ${colors.grey3};
	height: 24px;
	margin: 0 16px;
	align-self: center;
`;

export const ResizeContainer = styled.div`
	display: flex;
	justify-content: center;
	position: relative;
	width: 100%;
	height: 0px;
	overflow: visible;
`;

export const ResizeHandleIcon = styled(ApButtonIcon)`
	position: absolute;
	top: -32px;
	z-index: 1;
	margin: 0 auto;
`;
